 /*================ Content Factory
  ========================================*/
  angular
    .module('vppApp')
    .factory('contentAccordionFactory', contentAccordionFactory);

    contentAccordionFactory.$inject = ['$http', '$rootScope', '$log', 'vppConfig', '$state', 'VarientService'];

    function contentAccordionFactory($http, $rootScope, $log, vppConfig, $state, VarientService){
      return function(){
        var noVarient = "";
        var thisVarient;
        var getVarient = VarientService.getVarientName();

        /* === comment when varient needs to work ===*/
        // thisVarient = noVarient;
        /* === uncomment when varient needs to work ===*/
        if (getVarient && ($state.current.name === 'promote.main')) {
          var thisVarient = "-" + getVarient;

          // This is a hacky workaround because GMIT is unable to open a new CR in time for our deploy to get this to the correct URL
          // We need to have the vanity URL go to the homepage, but the vanity URL is currently going to /promote/
          // if (getVarient === 'soty') thisVarient = noVarient;
        } else {
         var thisVarient = noVarient;
        }
        // Disable SOTY
        console.log('thisVarient: ' + thisVarient);
        if (thisVarient.indexOf('soty') !== -1) thisVarient = noVarient;
        var Url = vppConfig.contentAccordionPath + "accordion-" + $state.current.name + thisVarient +".json";
        var promise = $http.get(Url).then(function successCallback(data){
        return data;
      }, function errorCallback (data){
        return data;
      });

      return promise;
      };

  }